import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'jd-618-super-discount-2026': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20lifestyle%20scene%20with%20warm%20golden%20tones%2C%20clean%20composition%2C%20soft%20natural%20lighting%2C%20elegant%20and%20simple%20aesthetic%2C%20high%20quality%20editorial%20photography&width=800&height=400&seq=art-jd618&orientation=landscape',
  'video-membership-comparison-2026': 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20large%20TV%20screen%2C%20warm%20lighting%2C%20modern%20minimalist%20interior%2C%20comfortable%20sofa%2C%20entertainment%20setup%2C%20soft%20golden%20hour%20light%2C%20clean%20aesthetic&width=800&height=400&seq=art-video&orientation=landscape',
  'shenzhen-consumer-voucher-2026': 'https://readdy.ai/api/search-image?query=Bright%20modern%20cityscape%20of%20Shenzhen%20with%20warm%20sunset%20light%2C%20clean%20architecture%2C%20shopping%20district%2C%20vibrant%20urban%20scene%2C%20golden%20hour%20glow%2C%20elegant%20composition&width=800&height=400&seq=art-sz-voucher&orientation=landscape',
};

export default function FeaturedArticles() {
  const hotArticles = getHotArticles();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                热门福利推荐
              </h2>
              <p className="text-sm text-foreground-500">
                编辑精选的最新最热福利攻略
              </p>
            </div>
            <Link
              to="/category/discount"
              className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {hotArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={articleImages[article.slug] || articleImages['jd-618-super-discount-2026']}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                      热门
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs text-foreground-400">{article.date}</span>
                    <span className="text-xs text-foreground-400">·</span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                    <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs">
                      {article.categoryName}
                    </span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-8 text-center sm:hidden">
            <Link
              to="/category/discount"
              className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium"
            >
              查看全部福利
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}